import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiDiarioOperacao = {
    page: async (page) => {
        const URL = `${apiLink()}api/diario-operacao?page=${page}`;
        return await axiosInstance.get(URL)
        .then((res) => res)
        .catch(error => {
            console.error('Erro ao buscar os dados:', error);
            throw new Error(error);
        })
    },
    create: async (data) => {
        const URL = `${apiLink()}api/diario-operacao`;
        return await axiosInstance.post(URL, data).then((res) => res)
        .catch(error => {
            console.error('Erro ao criar o registro:', error);
            throw new Error(error);
        })
    },
    update: async (data, id) => {
        const URL = `${apiLink()}api/diario-operacao/${id}`;
        return await axiosInstance.put(URL, data).then((res) => res)
        .catch(error => {
            console.error('Erro ao atualizar o registro:', error);
            throw new Error(error);
        })
    },
    delete: async (id) => {
        const URL = `${apiLink()}api/diario-operacao/status/${id}`
        return await axiosInstance.get(URL).then((res) => res)
        .catch(error => {
            console.error('Erro ao deletar o registro:', error);
            throw new Error(error);
        })
    },

}

export default apiDiarioOperacao;
